
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick, computed } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Charts, Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      option1: [],
      option2: [],
      option3: [],
      columns: [],
      data: [],
      spinning: true,
      activeKey: 'OperatingReenue',
      activeKeyName: 'MainOperIncome',
      pagination1: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      pagination: false,
      selectoptions: [],
      value1: '',
      handerlegend1: [],
      handerlegend2: [],
      handerlegend3: [],
      overflow: {},
      getPopupContainer: (e: HTMLElement) => e.parentNode
    })
    const color = globalsets.getColor()

    pageData.columns = [
      {
        title: '分类',
        dataIndex: 'Classification',
        key: 'Classification',
        width: '70px',
        customRender: (value: any) => {
          const obj: any = {
            children: value.text,
            props: {}
          }
          const arr = pageData.data.filter((res: any) => {
            // 这里gpsNumber是我需要判断的字段名（相同就合并）
            return res.Classification === value.text
          })
          if (value.index === 0 || pageData.data[value.index - 1].Classification !== value.text) {
            obj.props.rowSpan = arr.length
          } else {
            obj.props.rowSpan = 0
          }
          return obj
        }
      },
      {
        title: '业务名称',
        dataIndex: 'Project',
        key: 'Project',
        width: '110px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '营业收入(元)',
        dataIndex: 'MainOperIncome',
        key: 'MainOperIncome',
        width: '80px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '收入比例',
        dataIndex: 'OperatingReenue',
        key: 'OperatingReenue',
        width: '80px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '营业成本(元)',
        dataIndex: 'MainOperCost',
        key: 'MainOperCost',
        width: '80px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '成本比例',
        dataIndex: 'OperCost',
        key: 'OperCost',
        width: '80px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '利润比例',
        dataIndex: 'MainprofitReenue',
        key: 'MainprofitReenue',
        width: '80px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '毛利率',
        dataIndex: 'GrossProfit',
        key: 'GrossProfit',
        width: '80px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    pageData.handerlegend1 = computed((e: any) => {
      let data = pageData.data.filter((item: any) => {
        return item.ClassificationMethod === 10
      })
      let i = 0
      data.forEach((item: any) => {
        i += item[pageData.activeKey] || 0
      })
      if (i === 0) data = []
      return data || []
    })
    pageData.handerlegend2 = computed((e: any) => {
      let data = pageData.data.filter((item: any) => {
        return item.ClassificationMethod === 20
      })
      let i = 0
      data.forEach((item: any) => {
        i += item[pageData.activeKey] || 0
      })
      if (i === 0) data = []
      return data || []
    })
    pageData.handerlegend3 = computed((e: any) => {
      let data = pageData.data.filter((item: any) => {
        return item.ClassificationMethod === 30
      })
      let i = 0
      data.forEach((item: any) => {
        i += item[pageData.activeKey] || 0
      })
      if (i === 0) data = []
      return data || []
    })
    function handleChange() {
      handleData((props.pageSourceData || {}).BusinessCompositionData)
    }
    function handleData(val: any) {
      let list = []
      const data = JSON.parse(JSON.stringify(val))
      list = data.filter((item: any) => item.EndDate === pageData.value1)
      data.forEach((item: any, i: number) => {
        item.index = 'BusinessCompositionData' + i
        item.OperatingReenue = item.OperatingReenue * 100
        item.OperCost = item.OperCost * 100
        item.MainprofitReenue = item.MainprofitReenue * 100
        item.GrossProfit = item.GrossProfit * 100
        item.ratio = globalsets.getPencent(item[pageData.activeKey])
      })
      const data1: any = list.filter((item: any) => item.ClassificationMethod === 10)
      const data2: any = list.filter((item: any) => item.ClassificationMethod === 20)
      const data3: any = list.filter((item: any) => item.ClassificationMethod === 30)
      data1.sort((a: any, b: any) => b.MainOperIncome - a.MainOperIncome)
      data2.sort((a: any, b: any) => b.MainOperIncome - a.MainOperIncome)
      data3.sort((a: any, b: any) => b.MainOperIncome - a.MainOperIncome)
      pageData.data = data1.concat(data2, data3)
      setoption1()
      setoption2()
      setoption3()
    }
    function changetab() {
      switch (pageData.activeKey) {
        case 'OperatingReenue':
          pageData.activeKeyName = 'MainOperIncome'
          break
        case 'OperCost':
          pageData.activeKeyName = 'MainOperCost'
          break
        case 'MainprofitReenue':
          pageData.activeKeyName = 'Mainprofit'
          break
      }
      setoption1()
      setoption2()
      setoption3()
    }
    function setoption1() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      let _data = []
      _data = data.filter((item: any) => {
        item.ratio = item[pageData.activeKey] ? item[pageData.activeKey].toFixed(2) + '%' : null
        item.value = item[pageData.activeKeyName]
        return item.ClassificationMethod === 10
      })
      const seriesData = _data.map((item: any) => ({ name: item.Project, value: item.value, ratio: item.ratio }))
      pageData.option1 = {
        color: color,
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div class="optiontooltip"><p>${data.name}</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.ratio}</div>`
          }
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            center: [70, ' 50%'],
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function setoption2() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      let _data = []
      _data = data.filter((item: any) => {
        item.ratio = item[pageData.activeKey] ? item[pageData.activeKey].toFixed(2) + '%' : null
        item.value = item[pageData.activeKeyName]
        return item.ClassificationMethod === 20
      })
      const seriesData = _data.map((item: any) => ({ name: item.Project, value: item.value, ratio: item.ratio }))
      pageData.option2 = {
        color: color,
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div class="optiontooltip"><p>${data.name}</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.ratio}</div>`
          }
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            center: [70, ' 50%'],
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    function setoption3() {
      const data = JSON.parse(JSON.stringify(pageData.data))
      let _data = []
      _data = data.filter((item: any) => {
        item.ratio = item[pageData.activeKey] ? item[pageData.activeKey].toFixed(2) + '%' : null
        item.value = item[pageData.activeKeyName]
        return item.ClassificationMethod === 30
      })
      const seriesData = _data.map((item: any) => ({ name: item.Project, value: item.value, ratio: item.ratio }))
      pageData.option3 = {
        color: color,
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: function(params: any) {
            const { data, color } = params
            // '{b}<br /> <i style="width: 10px;height: 10px;border-radius: 50%;"></i>比例： {d}%'
            return `<div class="optiontooltip"><p>${data.name}</p><div style="width: 10px;height: 10px;border-radius: 50%;display:inline-block;background-color: ${color}"></div> 比例： ${data.ratio}</div>`
          }
        },
        series: [
          {
            type: 'pie',
            radius: '70%',
            center: [70, ' 50%'],
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
    let timer: any = null
    function isoverflow(item: any, e: any) {
      const index = item.index
      const tooltip: any = {}
      tooltip[index] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[index]) {
        if (!timer) {
          timer = setTimeout(() => {
            pageData.overflow[index] = true
          }, 400)
        }
      }
    }
    function hidetool(item: any, i: number) {
      const index = item.index
      if (timer) {
        setTimeout(() => {
          pageData.overflow[index] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    watch(
      () => (props.pageSourceData || {}).BusinessCompositionData || [],
      (val: any) => {
        pageData.selectoptions = [...new Set(val.map((item: any) => item.EndDate))]
        pageData.value1 = pageData.selectoptions[0]
        nextTick(() => {
          handleData(val)
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      moment: window.moment,
      handleChange,
      changetab,
      color,
      isoverflow,
      hidetool
    }
  }
})
